<main class="main w-full min-h-screen p-2 lg:w-2/3 mx-auto relative">
  <app-logo></app-logo>
  <app-navigation *ngIf="shouldShowNavigation"></app-navigation>
  <mat-divider></mat-divider>
  <div class="content w-full pb-12 min-h-full">
    <router-outlet></router-outlet>
  </div>
  <app-footer *ngIf="shouldShowNavigation"></app-footer>
</main>
